"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = matchRegex;
var _utils = require("../utils");
var _lib = require("../lib");
var _constants = require("../constants");
function matchRegex(value) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  (0, _utils.assertStringOrNumber)(value);
  var message = options.message,
    isPassword = options.isPassword;
  var key = options.key || 'key';
  var defaultRegex = '.*';
  if (isPassword) {
    defaultRegex = _constants.RX_PASSWORD;
  }
  var validRegex = new RegExp(options.validRegex || defaultRegex, 'i');
  var validity = (0, _utils.createValidity)(key || 'key');
  if (value.length > 0 && !validRegex.test(value)) {
    var label = options.label || 'Field';
    var messageOptions = {
      key: key,
      message: message,
      label: label,
      validRegex: validRegex
    };
    validity.isValid = false;
    validity.message = (0, _lib.getMessage)(messageOptions, "".concat(label, " does not match the format"));
  }
  return validity;
}


//////////////////
// WEBPACK FOOTER
// ./~/@mhub/web-validations/dist/validations/matchRegex.js
// module id = 1891
// module chunks = 0